import { Types as TypesModule } from '@/app/store_growth/store/Index'

import { getStoresWithinRadius } from '@/app/store_growth/Services'
import { getWideGrid, downloadWideGridToExcel } from '@/app/sales_analysis/Services'
import filters, { Types as TypesFilters } from '@/app/shared/store/modules/Filters'

import { addNamespace } from '@/app/shared/utils/NamespaceHelper'

import breadCrumb, { Types as TypesBreadCrumb } from '@/app/sales_analysis/store/BreadCrumb'
import Dimension from '@/app/sales_analysis/models/Dimension'

const NAMESPACE = 'storeGrowth/storesWithoutGrowthDetail/'
const STORE_BREADCRUMB_MODULE_NAME = 'storeBreadCrumb'
const PRODUCT_BREADCRUMB_MODULE_NAME = 'productBreadCrumb'
const NAMESPACE_STORE_BREADCRUMB = NAMESPACE + STORE_BREADCRUMB_MODULE_NAME + '/'
const NAMESPACE_PRODUCT_BREADCRUMB = NAMESPACE + PRODUCT_BREADCRUMB_MODULE_NAME + '/'

const _types = {
  getters: {
    DIMENSIONS: 'GETTER_DIMENSIONS',
    DIMENSION_BY_ID: 'GETTER_DIMENSION_BY_ID',
    STORE_DIMENSIONS: 'GETTER_STORE_DIMENSIONS',
    PRODUCT_DIMENSIONS: 'GETTER_PRODUCT_DIMENSIONS',
    STORE_DEFAULT_DIMENSION: 'GETTER_STORE_DEFAULT_DIMENSION',
    PRODUCT_DEFAULT_DIMENSION: 'GETTER_PRODUCT_DEFAULT_DIMENSION',
    PIVOT_PRODUCT_DIMENSIONS: 'GETTER_PIVOT_PRODUCT_DIMENSIONS',
    PIVOT_STORE_DIMENSIONS: 'GETTER_PIVOT_STORE_DIMENSIONS',
    PRODUCT_DIMENSION_TO_FILTER: 'GETTER_PRODUCT_DIMENSION_TO_FILTER',
    STORE_DIMENSION_TO_FILTER: 'GETTER_STORE_DIMENSION_TO_FILTER',
    PIVOTED_PRODUCT_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_PRODUCT_FILTER_DIMENSION_IDS',
    PIVOTED_STORE_FILTER_DIMENSION_IDS: 'GETTER_PIVOTED_STORE_FILTER_DIMENSION_IDS',
    BASE_STORE_DIMENSION: 'GETTER_BASE_STORE_DIMENSION',
    BASE_PRODUCT_DIMENSION: 'GETTER_BASE_PRODUCT_DIMENSION',
    LAST_PRODUCT_BREADCRUMB_ITEM: 'LAST_PRODUCT_BREADCRUMB_ITEM',
    LAST_STORE_BREADCRUMB_ITEM: 'LAST_STORE_BREADCRUMB_ITEM',
    CREATE_FILTER_OBJECT: 'CREATE_FILTER_OBJECT'
  },
  actions: {
    INIT: 'INIT',
    DEFAULT_FILTERS: 'DEFAULT_FILTERS',
    INIT_DIMENSIONS: 'INIT_DIMENSIONS',
    INIT_PRODUCT_DIMENSION: 'INIT_PRODUCT_DIMENSION',
    INIT_STORE_DIMENSION: 'INIT_STORE_DIMENSION',
    INIT_PRODUCT_BREADCRUMB: 'INIT_PRODUCT_BREADCRUMB',
    INIT_STORE_BREADCRUMB: 'INIT_STORE_BREADCRUMB',
    INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID: 'INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID',
    CHANGE_BASE_PRODUCT_DIMENSION: 'CHANGE_BASE_PRODUCT_DIMENSION',
    CHANGE_BASE_STORE_DIMENSION: 'CHANGE_BASE_STORE_DIMENSION',
    PIVOT_PRODUCT: 'PIVOT_PRODUCT',
    PIVOT_STORE: 'PIVOT_STORE',
    POP_UNTIL_STORE_BREADCRUMB: 'POP_UNTIL_STORE_BREADCRUMB',
    POP_UNTIL_PRODUCT_BREADCRUMB: 'POP_UNTIL_PRODUCT_BREADCRUMB',
    DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL',
    PUSH_BREADCRUMB_PRODUCT_ITEM: 'PUSH_BREADCRUMB_PRODUCT_ITEM',
    PUSH_BREADCRUMB_STORE_ITEM: 'PUSH_BREADCRUMB_STORE_ITEM',
    RESET: 'RESET',
    REMOVE_PIVOTED_FILTERS: 'REMOVE_PIVOTED_FILTERS',
    FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID: 'FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID',
    FETCH_STORES_WITHIN_RADIUS: 'FETCH_STORES_WITHIN_RADIUS'
  },
  mutations: {
    SET_GRID: 'SET_GRID',
    SET_STORE_IDS: 'SET_STORE_IDS'
  }
}
export const Types = addNamespace(NAMESPACE, _types)

const StoresWithoutGrowthDetail = {
  namespaced: true,
  state: {
    grid: null,
    storeIds: null
  },
  mutations: {
    [_types.mutations.SET_GRID] (state, wideGrid) {
      state.grid = wideGrid
    },
    [_types.mutations.SET_STORE_IDS] (state, storeIds) {
      state.storeIds = storeIds
    }
  },
  actions: {
    async [_types.actions.FETCH_STORES_WITHIN_RADIUS] ({ commit }, { storeId, radius = 1000 }) {
      const storeIds = await getStoresWithinRadius(storeId, radius)
      commit(_types.mutations.SET_STORE_IDS, storeIds)
    },
    async [_types.actions.INIT] ({ commit, dispatch }, storeId) {
      await dispatch(_types.actions.FETCH_STORES_WITHIN_RADIUS, { storeId })
      dispatch(_types.actions.DEFAULT_FILTERS)
      dispatch(_types.actions.INIT_DIMENSIONS)
      await dispatch(_types.actions.INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID)
    },
    async [_types.actions.DEFAULT_FILTERS] ({ dispatch, state }) {
      const { storeIds } = state
      const storeFilters = { store_type_id: [1], store_id: storeIds }
      dispatch(NAMESPACE + TypesFilters.actions.SET_SELECTED_FILTERS, { storeFilters }, { root: true })
    },
    [_types.actions.INIT_DIMENSIONS] ({ dispatch }) {
      dispatch(_types.actions.INIT_PRODUCT_DIMENSION)
      dispatch(_types.actions.INIT_STORE_DIMENSION)
    },
    [_types.actions.INIT_PRODUCT_DIMENSION] ({ getters, dispatch }) {
      const productDefaultDimension = getters[_types.getters.PRODUCT_DEFAULT_DIMENSION]
      dispatch(_types.actions.INIT_PRODUCT_BREADCRUMB, productDefaultDimension)
    },
    [_types.actions.INIT_STORE_DIMENSION] ({ getters, dispatch }) {
      // const storeDefaultDimension = getters[_types.getters.STORE_DEFAULT_DIMENSION]
      const storeDefaultDimension = getters[_types.getters.STORE_DIMENSIONS].find(store => store.key === 'store_id')
      dispatch(_types.actions.INIT_STORE_BREADCRUMB, storeDefaultDimension)
    },
    async [_types.actions.CHANGE_BASE_PRODUCT_DIMENSION] ({ dispatch, getters, rootGetters }, dimensionId) {
      const productDimension = getters[_types.getters.DIMENSION_BY_ID](dimensionId)
      const storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
      const pivotedProductFilters = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.FILTERS]
      dispatch(_types.actions.REMOVE_PIVOTED_FILTERS, pivotedProductFilters)
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { productDimension, storeDimension })
      dispatch(_types.actions.INIT_PRODUCT_BREADCRUMB, productDimension)
    },
    async [_types.actions.CHANGE_BASE_STORE_DIMENSION] ({ dispatch, getters, rootGetters }, dimensionId) {
      const storeDimension = getters[_types.getters.DIMENSION_BY_ID](dimensionId)
      const productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
      const pivotedStoreFilters = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.FILTERS]
      dispatch(_types.actions.REMOVE_PIVOTED_FILTERS, pivotedStoreFilters)
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { productDimension, storeDimension })
      dispatch(_types.actions.INIT_STORE_BREADCRUMB, storeDimension)
    },
    [_types.actions.INIT_PRODUCT_BREADCRUMB] ({ commit, dispatch }, dimension) {
      commit(NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.mutations.RESET, null, { root: true })
      dispatch(_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, { dimension, filter: undefined, breadCrumbItemText: dimension.value })
    },
    [_types.actions.INIT_STORE_BREADCRUMB] ({ commit, dispatch }, dimension) {
      commit(NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.mutations.RESET, null, { root: true })
      dispatch(_types.actions.PUSH_BREADCRUMB_STORE_ITEM, { dimension, filter: undefined, breadCrumbItemText: dimension.value })
    },
    [_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM] ({ commit }, { dimension, filter, breadCrumbItemText }) {
      commit(NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.mutations.PUSH_ITEM, { dimension, filter, text: breadCrumbItemText }, { root: true })
      if (filter) commit(NAMESPACE + TypesFilters.mutations.ADD_SELECTED_FILTER, filter, { root: true })
    },
    [_types.actions.PUSH_BREADCRUMB_STORE_ITEM] ({ commit }, { dimension, filter, breadCrumbItemText }) {
      commit(NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.mutations.PUSH_ITEM, { dimension, filter, text: breadCrumbItemText }, { root: true })
      if (filter) commit(NAMESPACE + TypesFilters.mutations.ADD_SELECTED_FILTER, filter, { root: true })
    },
    async [_types.actions.INIT_STORES_WITHOUT_GROWTH_DETAIL_GRID] ({ dispatch, rootGetters }) {
      const productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
      const storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { productDimension, storeDimension })
    },
    async [_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID] ({ commit, state, rootState, dispatch, rootGetters }, { productDimension, storeDimension, productStrategyFilter, storeStrategyFilter }) {
      dispatch(_types.actions.DEFAULT_FILTERS)
      const { filters } = state
      const metrics = rootGetters[TypesModule.getters.METRICS]
      const factTableName = rootState.storeGrowth.accumulatedSalesDateOption.fact_name
      commit(_types.mutations.SET_GRID, null)
      const wideGrid = await getWideGrid({ metrics, productDimension, storeDimension, factTableName, productStrategyFilter, storeStrategyFilter, filters })
      commit(_types.mutations.SET_GRID, wideGrid)
    },
    async [_types.actions.PIVOT_PRODUCT] ({ dispatch, getters, rootGetters }, { pivotedDimensionId, filter, pivotedDimensionCellValue }) {
      const productDimension = getters[_types.getters.DIMENSION_BY_ID](pivotedDimensionId)
      const breadCrumbItemText = `${productDimension.value} en ${pivotedDimensionCellValue}`
      const storeDimension = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]

      const productStrategyFilter = filter
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { productDimension, productStrategyFilter, storeDimension })
      dispatch(_types.actions.PUSH_BREADCRUMB_PRODUCT_ITEM, { dimension: productDimension, filter: filter, breadCrumbItemText })
    },
    async [_types.actions.PIVOT_STORE] ({ dispatch, getters, rootGetters }, { pivotedDimensionId, filter, pivotedDimensionCellValue }) {
      const storeDimension = getters[_types.getters.DIMENSION_BY_ID](pivotedDimensionId)
      const breadCrumbItemText = `${storeDimension.value} en ${pivotedDimensionCellValue}`
      const productDimension = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
      const storeStrategyFilter = filter
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { productDimension, storeStrategyFilter, storeDimension })
      dispatch(_types.actions.PUSH_BREADCRUMB_STORE_ITEM, { dimension: storeDimension, filter: filter, breadCrumbItemText })
    },
    async [_types.actions.POP_UNTIL_STORE_BREADCRUMB] ({ commit, dispatch, rootGetters }, breadCrumbItem) {
      if (rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM] === breadCrumbItem) return
      while (rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM] !== breadCrumbItem) {
        const lastBreadCrumbStoreItem = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
        commit(NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.mutations.REMOVE_ITEM, lastBreadCrumbStoreItem, { root: true })
        dispatch(NAMESPACE + TypesFilters.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbStoreItem.filter, { root: true })
      }
      const { dimension: storeDimension, filter: storeStrategyFilter } = breadCrumbItem
      const { dimension: productDimension, filter: productStrategyFilter } = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { storeDimension, storeStrategyFilter, productDimension, productStrategyFilter })
    },
    async [_types.actions.POP_UNTIL_PRODUCT_BREADCRUMB] ({ commit, dispatch, rootGetters }, breadCrumbItem) {
      if (rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM] === breadCrumbItem) return
      while (rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM] !== breadCrumbItem) {
        const lastBreadCrumbProductItem = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
        commit(NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.mutations.REMOVE_ITEM, lastBreadCrumbProductItem, { root: true })
        dispatch(NAMESPACE + TypesFilters.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, lastBreadCrumbProductItem.filter, { root: true })
      }
      const { dimension: storeDimension, filter: storeStrategyFilter } = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      const { dimension: productDimension, filter: productStrategyFilter } = breadCrumbItem
      await dispatch(_types.actions.FETCH_STORES_WITHOUT_GROWTH_DETAIL_GRID, { storeDimension, storeStrategyFilter, productDimension, productStrategyFilter })
    },
    [_types.actions.RESET] ({ commit }) {
      commit(NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.mutations.RESET, null, { root: true })
      commit(NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.mutations.RESET, null, { root: true })
      commit(_types.mutations.SET_GRID, null)
    },
    [_types.actions.REMOVE_PIVOTED_FILTERS] ({ dispatch }, pivotedFilters) {
      pivotedFilters.forEach((pivotedFilter) => {
        dispatch(NAMESPACE + TypesFilters.actions.REMOVE_SELECTED_FILTER_IN_CASCADE, pivotedFilter, { root: true })
      })
    },
    async [_types.actions.DOWNLOAD_EXCEL] ({ state, getters, rootState, rootGetters }) {
      const { filters } = state
      const metrics = rootGetters[TypesModule.getters.METRICS]
      const factTableName = rootState.storeGrowth.accumulatedSalesDateOption.fact_name
      const { dimension: storeDimension, filter: storeStrategyFilter } = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      const { dimension: productDimension, filter: productStrategyFilter } = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
      await downloadWideGridToExcel({ metrics, filters, factTableName, storeDimension, storeStrategyFilter, productDimension, productStrategyFilter })
    }
  },
  getters: {
    [_types.getters.DIMENSIONS]: (state, getters, rootState, rootGetters) => {
      return rootGetters.dataDimensions.map((dimension) => new Dimension(dimension))
    },
    [_types.getters.DIMENSION_BY_ID]: (state, getters) => (dimensionId) => {
      return getters[_types.getters.DIMENSIONS].find((dimension) => dimension.id === dimensionId)
    },
    [_types.getters.STORE_DIMENSIONS]: (state, getters) => {
      return getters[_types.getters.DIMENSIONS].filter((dimension) => dimension.type === 'store')
    },
    [_types.getters.STORE_DEFAULT_DIMENSION]: (state, getters) => {
      const storeDimensions = getters[_types.getters.STORE_DIMENSIONS]
      return storeDimensions.find((dimension) => dimension.selected) || storeDimensions[0]
    },
    [_types.getters.PRODUCT_DIMENSIONS]: (state, getters) => {
      return getters[_types.getters.DIMENSIONS].filter((dimension) => dimension.type === 'product')
    },
    [_types.getters.PRODUCT_DEFAULT_DIMENSION]: (state, getters) => {
      const productDimensions = getters[_types.getters.PRODUCT_DIMENSIONS]
      return productDimensions.find((dimension) => dimension.selected) || productDimensions[0]
    },
    [_types.getters.PIVOT_PRODUCT_DIMENSIONS]: (state, getters, rootState, rootGetters) => {
      const dimensionIdsInProductBreadCrumb = rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_IDS_IN_BREADCRUMB]
      const dimensionsToPivot = (dimension) => !dimensionIdsInProductBreadCrumb.includes(dimension.id)
      return getters[_types.getters.PRODUCT_DIMENSIONS].filter(dimensionsToPivot)
    },
    [_types.getters.PIVOT_STORE_DIMENSIONS]: (state, getters, rootState, rootGetters) => {
      const dimensionIdsInStoreBreadCrumb = rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_IDS_IN_BREADCRUMB]
      const dimensionsToPivot = (dimension) => !dimensionIdsInStoreBreadCrumb.includes(dimension.id)
      return getters[_types.getters.STORE_DIMENSIONS].filter(dimensionsToPivot)
    },
    [_types.getters.PRODUCT_DIMENSION_TO_FILTER]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
    },
    [_types.getters.STORE_DIMENSION_TO_FILTER]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_TO_FILTER]
    },
    [_types.getters.PIVOTED_PRODUCT_FILTER_DIMENSION_IDS]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_IDS_IN_FILTERS]
    },
    [_types.getters.PIVOTED_STORE_FILTER_DIMENSION_IDS]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.DIMENSION_IDS_IN_FILTERS]
    },
    [_types.getters.BASE_PRODUCT_DIMENSION]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.FIRST_ITEM].dimension
    },
    [_types.getters.BASE_STORE_DIMENSION]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.FIRST_ITEM].dimension
    },
    [_types.getters.LAST_PRODUCT_BREADCRUMB_ITEM]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_PRODUCT_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
    },
    [_types.getters.LAST_STORE_BREADCRUMB_ITEM]: (state, getters, rootState, rootGetters) => {
      return rootGetters[NAMESPACE_STORE_BREADCRUMB + TypesBreadCrumb.getters.LAST_ITEM]
    },
    [_types.getters.CREATE_FILTER_OBJECT]: (state) => (filter) => {
      const filterAttribute = `${filter.keyFieldType}_filters`
      return { [filterAttribute]: { [filter.keyField]: filter.value } }
    }
  },
  modules: {
    filters,
    [STORE_BREADCRUMB_MODULE_NAME]: breadCrumb,
    [PRODUCT_BREADCRUMB_MODULE_NAME]: breadCrumb
  }
}

export default StoresWithoutGrowthDetail



// WEBPACK FOOTER //
// ./src/app/store_growth/store/StoresWithoutGrowthDetail.js